var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12 mb-3" },
      [
        _c("section-title", {
          attrs: { "has-line": "", title: "Introducir Meta" }
        }),
        _c("validation-provider", {
          ref: "goalDescValidator",
          attrs: { rules: "required" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function({ errors }) {
                return [
                  _c("custom-input", {
                    attrs: {
                      "custom-error-msg":
                        "Favor escribir una descripción de la meta.",
                      error: errors[0],
                      label: "Introducir Meta:",
                      maxlength: "500",
                      type: "text"
                    },
                    model: {
                      value: _vm.goal.description,
                      callback: function($$v) {
                        _vm.$set(_vm.goal, "description", $$v)
                      },
                      expression: "goal.description"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm.showAreaSelection && _vm.hasAreaOptions && _vm.isPeiSigned
      ? _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("validation-provider", {
              ref: "areaGoalValidator",
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("area-selection", {
                          ref: "areaSelection",
                          attrs: {
                            "area-options": _vm.areaOptions,
                            "selected-areas": _vm.goal.areaSelection
                          },
                          on: {
                            "cancel-add": _vm.cancel,
                            "cancel-update": _vm.cancel,
                            "save-area-selection": function($event) {
                              _vm.goal.areaSelection = $event
                            }
                          }
                        }),
                        _c("goal-selection", {
                          ref: "goalSelection",
                          attrs: {
                            "goal-options": _vm.filteredGoalOptions,
                            "selected-goals": _vm.goal.goalSelection
                          },
                          on: {
                            "save-goal-selection": function($event) {
                              _vm.goal.goalSelection = $event
                            }
                          }
                        }),
                        _c("SelectedGoalsAreas", {
                          attrs: { "selected-goals": _vm.goal }
                        }),
                        errors && errors.length
                          ? _c(
                              "ul",
                              { staticClass: "text-danger mt-2" },
                              _vm._l(errors, function(e, i) {
                                return _c("li", { key: i }, [_vm._v(_vm._s(e))])
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                false,
                3887895498
              )
            })
          ],
          1
        )
      : _vm._e(),
    _vm.showAreaSelection && !_vm.hasAreaOptions && _vm.isPeiSigned
      ? _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("Error", {
              attrs: {
                "is-alert-mode": "",
                message:
                  "Estudiante no cuenta con servicio educativo puede proceder a documentar metas y objetivos."
              }
            })
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "col-12 mt-2 d-flex justify-content-end" },
      [
        _c("action-button", {
          attrs: {
            i: "fas fa-times-circle",
            text: "Cancelar",
            variant: "outline-danger mr-3"
          },
          on: { click: _vm.cancel }
        }),
        _c("action-button", {
          attrs: { i: "fa fa-save", text: "Guardar", variant: "success" },
          on: { click: _vm.saveGoal }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }